import { render } from "./humVideoKxjPlayer.vue?vue&type=template&id=3b0cfd74&scoped=true"
import script from "./humVideoKxjPlayer.vue?vue&type=script&lang=js"
export * from "./humVideoKxjPlayer.vue?vue&type=script&lang=js"

import "./humVideoKxjPlayer.vue?vue&type=style&index=0&id=3b0cfd74&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0cfd74"]])

export default __exports__